export const GET_USER = "app/GET_USER";
export const SET_USER = "app/SET_USER";
export const UPDATE_USER = "app/UPDATE_USER";